export const env = {
  stage: import.meta.env.VITE_STAGE ?? (location.hostname.includes('pages.dev') ? 'preview' : 'prod'),
  apiBase: '/api'
};